import { Alert, AlertIcon, Box, Button, HStack, SimpleGrid, Stack, Text } from '@chakra-ui/react'

import { UserLink } from '@/components'
import { useAuth } from '@/context/AuthContext'
import type { PpzAuthorization } from '@/dtos'
import { useApprove } from '@/hooks/usePpzAuthorization'
import { Check } from '@/icons'
import { formatDate } from '@/utils/formatDate'

import { FormSection } from '../forms/FormSection'
import { EditablePpzAuthorizationFile } from './EditablePpzAuthorizationFile'
import { PpzAuthorizationAddFilesForm } from './PpzAuthorizationAddFilesForm'
import { PpzAuthorizationEditForm } from './PpzAuthorizationEditForm'

export const PpzAuthorizationDetail = (ppzAuthorization: PpzAuthorization) => {
  const { approvedById, approvedBy, approvedDate } = ppzAuthorization
  const { user } = useAuth()

  const { mutateAsync: approveAsync, isPending: isLoadingApprove } = useApprove(ppzAuthorization.id)

  return (
    <Stack gap={6}>
      <FormSection sectionTitle={
        <HStack justifyContent='space-between'>
          <Text>Platnost dokladu/osvědčení pojišťovacího zprostředkovatele</Text>
          {!approvedBy && user?.isSupervisor && <Button display='flex' gap={4} colorScheme='green' onClick={() => approveAsync()} isLoading={isLoadingApprove}>
            <Check />
            Potvrdit platnost
          </Button>}
        </HStack>
      } wide>
        <PpzAuthorizationEditForm {...ppzAuthorization} />
      </FormSection>
      {approvedBy &&
                <Alert status='success' w='auto' variant='solid' backgroundColor='green.400'>
                  <AlertIcon />
                  <Box>Autorizaci potvrdil{' '}
                    {approvedDate && 'dne ' + formatDate(approvedDate)}{' '}
                    <UserLink userId={approvedById} name={approvedBy} />
                  </Box>
                </Alert>
      }
      <FormSection sectionTitle={
        <HStack justifyContent='space-between'>
          <Text>Přiložené dokumenty</Text>
          <PpzAuthorizationAddFilesForm ppzAuthorizationId={ppzAuthorization.id} />
        </HStack>
      } wide>
        {ppzAuthorization.files.length > 0 ?
          <SimpleGrid columns={2} gap={4}>
            {ppzAuthorization.files.map((file) =>
              <EditablePpzAuthorizationFile key={file} file={file} ppzAuthorizationId={ppzAuthorization.id} />
            )}
          </SimpleGrid>
          :
          <Text fontSize='lg' color='gray.500'>Žádné soubory nebyly vybrány.</Text>
        }
      </FormSection>
    </Stack>
  )
}